module.exports = __webpack_public_path__ + "static/DT_devops-ab0ab1374392df41478a2072b7ad1ec8.png";